var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "-5.0 -10.0 110.0 135.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m79.168 27.082c3.3164 0 6.4922 1.3164 8.8398 3.6602 2.3438 2.3438 3.6602 5.5234 3.6602 8.8398v35.418c0 6.9023-5.5977 12.5-12.5 12.5h-58.199c-6.9023 0-12.5-5.5977-12.5-12.5v-50c0-6.9023 5.5977-12.5 12.5-12.5h22.793c3.0352 0 5.9492 1.207 8.0977 3.3555 2.1484 2.1484 3.3516 5.0586 3.3516 8.0977v0.015625c0 1.7227 1.3945 3.1172 3.1172 3.1172h20.844zm-24.867 29.523v-10.773c0-2.3008-1.8672-4.1641-4.168-4.1641-2.3008 0-4.1641 1.8672-4.1641 4.1641v10.773l-5.3867-5.3867c-1.6289-1.625-4.2656-1.625-5.8945 0-1.625 1.625-1.625 4.2656 0 5.8945l12.5 12.5c1.6289 1.6289 4.2656 1.6289 5.8945 0l12.5-12.5c1.625-1.625 1.625-4.2656 0-5.8945-1.6289-1.625-4.2656-1.625-5.8945 0z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown2);
export default __webpack_public_path__ + "static/media/down2.dcec1bb1bdc697cf8f15b7f4924365b8.svg";
export { ForwardRef as ReactComponent };